import type { CarouselProps } from "components/HomeCarousel/HomeCarousel"
import { breakpointsInPx, useScreenViewport } from "lib/checkViewport"

type SliderOptions = {
  itemsLength: number
  arrowDistance?: string
  itemToShowMobile?: number
  itemPerGroupMobile?: number
  isATBConfirmation?: boolean
}

export const useSliderWithThreeItems = ({
  itemsLength,
  arrowDistance = "-5.5rem",
  itemToShowMobile = 2.2,
  itemPerGroupMobile = 2,
  isATBConfirmation,
}: SliderOptions): CarouselProps => {
  const { isMobile } = useScreenViewport()
  return {
    showNavigation: itemsLength > 3 && !isMobile,
    prevBtnStyles: {
      left: `${arrowDistance} !important`,
    },

    nextBtnStyles: {
      right: `${arrowDistance} !important`,
    },
    slidesPerView: 1,
    breakpoints: {
      [breakpointsInPx.sm]: {
        slidesPerView: !isATBConfirmation ? 3 : 2,
        slidesPerGroup: 1,
      },
      [breakpointsInPx.xs]: {
        slidesPerView: itemToShowMobile,
        slidesPerGroup: itemPerGroupMobile,
      },
    },
  }
}

export const useSliderWithFourItems = ({
  itemsLength,
  arrowDistance = "-5.5rem",
}: SliderOptions): CarouselProps => {
  const { isMobile } = useScreenViewport()

  return {
    showNavigation: itemsLength > 4 && !isMobile,
    prevBtnStyles: {
      left: `${arrowDistance} !important`,
    },

    nextBtnStyles: {
      right: `${arrowDistance} !important`,
    },
    slidesPerView: 1,
    breakpoints: {
      [breakpointsInPx.lg]: {
        slidesPerView: 4,
        slidesPerGroup: 1,
      },
      [breakpointsInPx.md]: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      [breakpointsInPx.xs]: {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
      },
    },
  }
}
